// src/pages/TrialLanding.js
// /t/:code — records the referral code from the URL as attribution, then
// forwards to /trial. Staff hand a parent a permanent link like /t/sara.
//
// The code is NOT validated here. It's stored as an unverified claim —
// createTrialSignup resolves it against referralCodes server-side (Admin SDK),
// sets codeType, and writes code: null for anything unknown or inactive. Doing
// it here too would be redundant, would need a public read on referralCodes,
// and would add a round-trip to what should be an instant redirect.
//
// Attribution must NEVER block a signup: no lookup, nothing to fail. /trial
// reached directly, with no code at all, also works.
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  captureAttribution,
  setAttributionCode,
  normalizeReferralCode,
} from '../utils/attribution';

export default function TrialLanding() {
  const { code } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    // fbclid / referrer / landingPath, plus the raw code claim.
    captureAttribution();
    setAttributionCode(normalizeReferralCode(code) || null);
    navigate('/trial', { replace: true });
  }, [code, navigate]);

  return null;
}
